import { motion } from 'framer-motion';

export function WhatsAppDiagnostic() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/33745883392?text=Bonjour,%20je%20souhaite%20un%20diagnostic%20vidéo%20gratuit%20pour%20ma%20fenêtre', '_blank');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-green-50 via-white to-emerald-50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-200/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-green-500 text-white px-6 py-3 rounded-full text-base font-bold mb-6 shadow-lg">
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>NOUVEAU • 100% GRATUIT</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Diagnostic Vidéo par WhatsApp
          </h2>
          <p className="text-2xl text-gray-700 max-w-3xl mx-auto font-semibold">
            Envoyez une vidéo de votre fenêtre → Recevez un diagnostic gratuit en 2h
          </p>
        </motion.div>

        {/* Main Content: Text Left + Image Right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          {/* Left Column - Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="bg-white rounded-3xl p-10 shadow-2xl">
              <h3 className="text-3xl font-bold text-gray-900 mb-8">
                Comment ça marche ?
              </h3>

              {/* Steps */}
              <div className="space-y-6 mb-10">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xl font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Filmez votre fenêtre</h4>
                    <p className="text-gray-600">
                      Prenez une courte vidéo de votre fenêtre ou volet défectueux avec votre smartphone
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xl font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Envoyez via WhatsApp</h4>
                    <p className="text-gray-600">
                      Cliquez sur le bouton ci-dessous et envoyez votre vidéo directement sur WhatsApp
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xl font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Recevez le diagnostic</h4>
                    <p className="text-gray-600">
                      Notre expert analyse votre vidéo et vous envoie un diagnostic détaillé + devis sous 2h
                    </p>
                  </div>
                </div>
              </div>

              {/* Benefits */}
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-green-50 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-green-600 mb-1">0€</div>
                  <div className="text-sm text-gray-600">Totalement gratuit</div>
                </div>
                <div className="bg-teal-50 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-1">2h</div>
                  <div className="text-sm text-gray-600">Réponse rapide</div>
                </div>
                <div className="bg-orange/10 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-orange mb-1">Expert</div>
                  <div className="text-sm text-gray-600">Diagnostic pro</div>
                </div>
                <div className="bg-green-50 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-green-600 mb-1">7j/7</div>
                  <div className="text-sm text-gray-600">Disponible</div>
                </div>
              </div>

              {/* CTA Button */}
              <button
                onClick={handleWhatsAppClick}
                className="w-full inline-flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-5 rounded-xl text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-3xl"></i>
                <span>Lancer Mon Diagnostic Gratuit</span>
              </button>
              <p className="text-center text-gray-600 mt-4 text-sm">
                <i className="ri-shield-check-line text-green-600 mr-1"></i>
                Sans engagement • Réponse garantie
              </p>
            </div>
          </motion.div>

          {/* Right Column - Video Call Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[700px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/a0a699514f39e43ec8581caad986d96a.jpg"
                  alt="Diagnostic vidéo par WhatsApp pour réparation de fenêtres"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Floating Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-2xl p-6"
            >
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-video-line text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">Simple & Rapide</div>
                  <div className="text-sm text-gray-600">Diagnostic en visio</div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}